import Vue from 'vue'

Vue.filter('fixD', (value, presion) => {
  if (!value) return 0
  let str = value.toString()
  const index = str.indexOf('.')
  if (index < 0) return value
  str = str.slice(0, index + presion + 1)

  return str
})
